import "./patchReact";
import {
    MessengerProvider,
    FlagrProvider,
} from "@doopage-client-js/messenger-react";
import { ThemeProvider } from "@material-ui/core/styles";
import CatchErrorBoundary from "addOnComponent/CatchErrorBoundary";
import "config/FirebaseConfig";
import "config/GoogleAnalyticsConfig";
import "config/LogConfig";
import "config/SentryConfig";
import { MuiTheme } from "config/Theme";
import "css/classes.css";
import React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { render } from "react-dom";
import HttpsRedirect from "react-https-redirect";
import { Provider } from "react-redux";
import store from "redux/store";
import App2 from "screen/App/App2";
import register from "./registerServiceWorker";
import LocalStorage from "config/LocalStorage";
import { DOO_FLAGR_URL } from "config/Env";
import { DEFAULT_FLAGR_KEY_VALUE_MAP, STAFF_FLAGR_KEYS } from "constants/flagr";

const storageClientOptions = LocalStorage.getMessengerClientOptions();
const clientOptions = {
    ...storageClientOptions,
    staleClientThresholdMs: 86400 * 30 * 1000, // if user offline more than 30 days, client will clean data
};
console.log("options", clientOptions);

const queryClientConfig = {
    defaultOptions: {
        queries: {
            gcTime: 600 * 1000, // garbage memory store after 10 min query not used
        },
    },
    storagePersisterOptions: {
        maxAge: Infinity, // Set cache will store forever, unless useQuery specify custom meta: {maxAge: x}
        storage: localStorage,
    },
};

window.deferredPrompt = null;

window.addEventListener("beforeinstallprompt", (e) => {
    console.log("beforeinstallprompt fired in index.js", e);
    e.preventDefault();
    window.deferredPrompt = e;
    window.dispatchEvent(new CustomEvent("pwa-installable"));
});

window.addEventListener("appinstalled", () => {
    console.log("PWA was installed");
    window.deferredPrompt = null;
    window.dispatchEvent(new CustomEvent("pwa-installed"));
});

window.ResizeObserver = undefined;
render(
    <ThemeProvider theme={MuiTheme}>
        <CatchErrorBoundary showErrorScreen>
            <MessengerProvider
                clientOptions={clientOptions}
                queryClientConfig={queryClientConfig}
            >
                <FlagrProvider
                    flagrUrl={DOO_FLAGR_URL}
                    staffFlagKeys={STAFF_FLAGR_KEYS}
                    defaultFlagMap={DEFAULT_FLAGR_KEY_VALUE_MAP}
                >
                    <Provider store={store}>
                        <HttpsRedirect>
                            <DndProvider backend={HTML5Backend}>
                                <App2 />
                            </DndProvider>
                        </HttpsRedirect>
                    </Provider>
                </FlagrProvider>
            </MessengerProvider>
        </CatchErrorBoundary>
    </ThemeProvider>,
    document.getElementById("root")
);

register();
